var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMetroProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.049,
    height: 13.537,
    viewBox: "0 0 18.049 13.537"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-profile",
    fill: "currentColor",
    d: "M16.759 1.934h-1.258V.04L12.896 0l.005 1.934H5.076L5.13 0 2.579.04v1.934l-1.289-.04A1.29 1.29 0 00.001 3.223v9.024a1.29 1.29 0 001.289 1.289h15.47a1.29 1.29 0 001.289-1.289V3.223a1.29 1.29 0 00-1.29-1.289zM13.536.645h1.289v2.578h-1.289zm-8.38 4.391a1.678 1.678 0 011.41 1.853 1.678 1.678 0 01-1.41 1.853 1.678 1.678 0 01-1.41-1.854 1.678 1.678 0 011.41-1.853zM3.223.645h1.289v2.578H3.223zm-.859 10.28s.153-1.226.5-1.457a4.944 4.944 0 011.347-.385s.648.693.924.693.924-.693.924-.693a4.928 4.928 0 011.348.385c.408.272.51 1.457.51 1.457H2.363zm13.107-.611h-5.8v-.645h5.8zm0-1.289h-5.8V8.38h5.8zm0-1.289h-5.8v-.648h5.8zm0-1.289h-5.8v-.645h5.8z"
  })));
}

export default SvgIconMetroProfile;